import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { RESTAURANT } from "../../lib/restaurantData";
import { useT } from "../../lib/i18n";

export const Contact = () => {
  const { t } = useT();
  return (
    <section id="contatti" data-testid="contact-section" className="bg-[#0E1F35] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <span className="font-display text-xs tracking-[0.3em] text-[#E8C765] font-semibold">
              {t("contact.eyebrow")}
            </span>
            <h2 className="mt-4 font-script text-6xl sm:text-7xl lg:text-8xl leading-[1] text-white">
              {t("contact.title")}
            </h2>
            <p className="mt-5 text-white/80 text-base sm:text-lg leading-relaxed max-w-md font-serif-body italic">
              {t("contact.desc")}
            </p>

            <div className="mt-10 space-y-5">
              <a href={RESTAURANT.mapsLink} target="_blank" rel="noopener noreferrer" data-testid="contact-address-link" className="flex gap-4 items-start group">
                <span className="shrink-0 w-11 h-11 rounded-full bg-[#B59410] grid place-items-center">
                  <MapPin className="w-5 h-5 text-white" />
                </span>
                <span>
                  <span className="block font-display text-xs tracking-[0.22em] text-white/55 font-semibold">{t("contact.address")}</span>
                  <span className="block mt-1 text-white group-hover:text-[#E8C765] transition-colors font-serif-body text-base">
                    {RESTAURANT.address}
                  </span>
                </span>
              </a>

              <a href={RESTAURANT.phoneHref} data-testid="contact-phone-link" className="flex gap-4 items-start group">
                <span className="shrink-0 w-11 h-11 rounded-full bg-[#B59410] grid place-items-center">
                  <Phone className="w-5 h-5 text-white" />
                </span>
                <span>
                  <span className="block font-display text-xs tracking-[0.22em] text-white/55 font-semibold">{t("contact.phone")}</span>
                  <span className="block mt-1 text-white group-hover:text-[#E8C765] transition-colors font-serif-body text-base">
                    {RESTAURANT.phone}
                  </span>
                </span>
              </a>

              <a href={`mailto:${RESTAURANT.email}`} data-testid="contact-email-link" className="flex gap-4 items-start group">
                <span className="shrink-0 w-11 h-11 rounded-full bg-[#B59410] grid place-items-center">
                  <Mail className="w-5 h-5 text-white" />
                </span>
                <span>
                  <span className="block font-display text-xs tracking-[0.22em] text-white/55 font-semibold">{t("contact.email")}</span>
                  <span className="block mt-1 text-white group-hover:text-[#E8C765] transition-colors font-serif-body text-base">
                    {RESTAURANT.email}
                  </span>
                </span>
              </a>

              <div className="flex gap-4 items-start">
                <span className="shrink-0 w-11 h-11 rounded-full bg-[#B59410] grid place-items-center">
                  <Clock className="w-5 h-5 text-white" />
                </span>
                <div>
                  <span className="block font-display text-xs tracking-[0.22em] text-white/55 font-semibold">{t("contact.hours")}</span>
                  <ul className="mt-1 text-white space-y-1 text-sm font-serif-body">
                    <li className="flex gap-3">
                      <span className="text-white/65 w-32">{t("contact.hoursDay")}</span>
                      <span>11:30 – 23:00</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden border border-white/10 shadow-2xl bg-white/5 h-[420px] sm:h-[520px]">
            <iframe
              data-testid="google-maps-embed"
              title="Mappa Mama Cucina e Pizza"
              src={RESTAURANT.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>

      <footer className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/60 text-sm font-serif-body">
          <img src="/brand/logo-mama.png" alt="Mama" className="h-10 w-auto brightness-0 invert" />
          <span>© {new Date().getFullYear()} mAmA Cucina &amp; Pizza — {t("contact.copyright")}</span>
        </div>
      </footer>
    </section>
  );
};
